/***
 *
 *   HELP
 *   Information for user to get help and support
 *
 **********/

import React, { Fragment } from "react";
import Faq from "react-faq-component";

import "./faqs.scss";

export function Faqs(props) {
  const data = {
    title: "FAQS",
    rows: [
      {
        title: "What is KYC?",
        content: `KYC means Know Your Customer. A KYC Check is a process for validating the identity of an individual using government-issued identity documents. KYC is mandatory in many environments, including banks or other organisations prone to fraud. KYC is typically required in new account opening, or at other key stages of transactions.`,
      },
      {
        title: "How does the KYC process work at IdentityCheck?",
        content:
          "You can request KYC for any contact from within your CRM (E.g. HubSpot). IdentityCheck emails the contact a unique URL, which they click on to commence the KYC process. The contact is prompted to correctly take a picture of their government-issued documents, and a selfie. The images are used by our platform to determine if the identity is valid. The result (positive or negative), plus a link to the raw images are added to the contact record inside your CRM.",
      },
      {
        title: " What types of KYC documentation are accepted?",
        content: `IdentityCheck accepts over 10,000 document types from over 200 countries to verify the identity of an individual. This includes passport, drivers licence, ID card, and residency permits.`,
      },
      {
        title: "How does Identity Verification work?",
        content:
          "Once the KYC documents are submitted, over 1,000 data points are analysed through a device and network fingerprinting solution. The average decision time is made in just 6 seconds, and 95% are complete on the first try!",
      },
      {
        title: "Does IdentityCheck meet KYC compliance requirements?",
        content:
          "IdentityCheck is powered by a KYC platform that is compliant with GDPR, WCAG, CCPA, and SOC 2 Type II",
      },
      {
        title: "How are biometrics used for KYC verification?",
        content:
          "KYC verification is completed by leveraging more than 1,000 data points including device, network, document, video, biometric, and behavioural information. The platform that powers KYC checks uses biometric authentication to confirm a user is who they claim to be, and mitigates fraudulent activities including account takeover and identity theft.",
      },
      {
        title: "What happens if an ID verification fails?",
        content:
          "The reason for the failure can be found in the verification session itself, which you can access by clicking on the “Verification Link” from the client record in your Practice Management / CRM. For example, a common reason is ‘Attempted deceit, device screen used,’ which occurs because for security reasons, we do not accept images of ID documents—clients must use the original.",
      },
      {
        title:
          "Is there an expiry on verifications if they are left uncompleted?",
        content:
          "Yes, the checks expire after 7 days, but you can simply re-trigger the request if you need to.",
      },
      {
        title:
          "Why is a warning banner displayed on my IdentityCheck notification email?",
        content: (
          <>
            The warning is usually related to your inbox security settings,
            which are making you aware that tracking pixels (tiny, unseen images
            for tracking) exist in the email. Note that our completion rates are
            very high, and we have documented best practice{" "}
            <a
              href="https://stackgo.io/identitycheck/how-to-optimise-identitycheck-completion-rates/"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            if required.
          </>
        ),
      },
      {
        title: "Can I add custom branding (logo, colour scheme) to the forms?",
        content: (
          <>
            You can add your logo from{" "}
            <strong>Settings &gt; Custom Email</strong> in the interface, or
            send us a high-resolution PNG, and we can add it for you. A custom
            colour scheme is typically not included in the standard setup.
          </>
        ),
      },
    ],
  };

  const styles = {
    titleTextColor: "#6363AC",
    rowTitleColor: "#6363AC",
  };

  const config = {
    animate: true,
    // arrowIcon: "V",
    tabFocus: true,
  };

  return (
    <Fragment>
      <Faq data={data} styles={styles} config={config} />
    </Fragment>
  );
}
